export enum Realm {
  Eis = 'EIS',
  Lp = 'LP',
}
